import { Link } from 'react-router-dom';
import './Home.css';

function Home() {
  const trustLogos = [
    { name: 'Medibotx', src: '/Content/icons/medibotx/Medibotx-64x64.png' },
    { name: 'Smart Performance Analytics', src: '/Content/icons/SmartPerformanceAnalytics/analytics-64x64.png' },
    { name: 'Smart Case Management', src: '/Content/icons/casemgmt/Customer-Services-64x64.png' },
    { name: '247Shift', src: '/Content/icons/clock/clock-time-7.png' },
    { name: 'Robohound', src: '/Content/icons/robohound/robohound-64x64.png' },
    { name: 'Intellimatcher', src: '/Content/icons/intellimatcher/intellimatcher.svg' },
  ];

  const corePaths = [
    { title: 'Solutions', href: '/solutions', description: 'Enterprise-grade software strategies designed to solve complex operational challenges.' },
    { title: 'Products', href: '/products', description: 'Our comprehensive suite of AI-powered and professional management tools.' },
    { title: 'Consultancy', href: '/consultancy', description: 'Expert guidance for digital transformation and bespoke software development.' },
  ];

  return (
    <div className="home-gateway">
      <section className="gateway-hero">
        <div className="gateway-hero-content">
          <h1 className="gateway-hero-title">Enterprise Software <br />Solutions</h1>
          <p className="gateway-hero-subtitle">
            SMART-WARES builds intelligent, reliable software designed to automate, analyse, and transform your business operations.
          </p>
          <div className="gateway-hero-actions">
            <Link to="/solutions" className="button button-primary button-large">
              Explore Solutions
            </Link>
            <Link to="/products" className="button button-outline-white button-large">
              View Products
            </Link>
          </div>
        </div>
      </section>

      <section className="gateway-trust">
        <div className="container">
          <p className="trust-label">Powered by SMART-WARES</p>
          <div className="trust-grid">
            {trustLogos.map((logo) => (
              <div key={logo.name} className="trust-item">
                <img src={logo.src} alt={logo.name} title={logo.name} />
                <span>{logo.name}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="featured-ai-section">
        <div className="container">
          <div className="featured-ai-card">
            <div className="featured-ai-content">
              <span className="badge badge-purple">AI Innovation</span>
              <h2>Meet the Robohound AI Hub</h2>
              <p>
                A comprehensive AI ecosystem specializing in intelligent searching, indexing, analytics, and security to power the next generation of data-driven enterprises.
              </p>
              <div className="featured-ai-actions">
                <a 
                  href="https://robohound.ai"
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="button button-primary"
                >
                  Explore AI Platform ↗
                </a>
                <Link to="/products" className="button button-secondary">
                  View All Products →
                </Link>
              </div>
            </div>
            <div className="featured-ai-image">
              <img src="/Images/Robohound-Search-Pic.jpg" alt="Robohound AI Hub Interface" />
            </div>
          </div>
        </div>
      </section>

      <section className="gateway-paths">
        <div className="container">
          <div className="paths-grid">
            {corePaths.map((path) => (
              <Link key={path.title} to={path.href} className="path-card">
                <div className="path-card-content">
                  <h3>{path.title}</h3>
                  <p>{path.description}</p>
                </div>
                <div className="path-card-footer">
                  <span>Learn More →</span>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}

export default Home;